import { render, staticRenderFns } from "./WColorPicker.vue?vue&type=template&id=4986e780&"
import script from "./WColorPicker.vue?vue&type=script&lang=js&"
export * from "./WColorPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports